<template>
  <div class="columns">
    <div class="column is-half">
      <b-field label="Title">
        <b-input v-model="title" />
      </b-field>
      <b-field label="Subtitle">
        <b-input v-model="subtitle" />
      </b-field>
      <b-field grouped group-multiline label="Badges">
        <b-switch v-model="blockable">Blockable</b-switch>
        <b-switch v-model="unblockable">Unblockable</b-switch>
        <b-switch v-model="evadable">Evadable</b-switch>
        <b-switch v-model="warningBorder">Warning Border</b-switch>
      </b-field>
      <b-field>
        <b-switch v-model="breakbar">Enable defiance bar</b-switch>
      </b-field>
      <b-field label="Defiance bar text">
        <b-input v-model="breakbarText" />
      </b-field>
    </div>
    <div class="column is-half">
      <mechanic-card
          :title="title"
          :subtitle="subtitle"
          :img="require('./assets/todo.jpg')"
          img-alt="Testing Mechanic"
          :blockable="blockable"
          :evadable="evadable"
          :unblockable="unblockable"
          :breakbar="breakbar ? breakbarText : null"
          :warning-border="warningBorder"
      >
        <p>
          A short mechanic description.
        </p>
        <template #details>
          <p>
            A more detailed section explaining intricacies.
          </p>
          <p>
            Another paragraph that is not very long.
          </p>
        </template>
      </mechanic-card>
    </div>
  </div>
</template>

<script>
import MechanicCard from './components/MechanicCard'

export default {
  name: "MechanicDesigner",
  components: {MechanicCard},
  data() {
    return {
      blockable: true,
      unblockable: true,
      evadable: true,
      breakbar: false,
      warningBorder: false,
      breakbarText: "",
      title: "Mechanic name",
      subtitle: "Subtitle",
    }
  }
}
</script>

<style scoped>

</style>